import { application } from "./application"

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SyncController from "./sync_controller"
application.register("sync", SyncController)

import SyncProgressController from "./sync_progress_controller"
application.register("sync-progress", SyncProgressController)
